// Select KISS — wrapper em <select> native, estilizado com a classe .input
// (mesma base do handoff, campo unico de formulario).
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...rest }, ref) {
    return (
      <select ref={ref} className={cn("input", className)} {...rest}>
        {children}
      </select>
    );
  },
);
